import { useEffect, useState } from "react";
import "./AtivarClasseEstaleiroModal.css";

export default function AtivarClasseEstaleiroModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleConfirmar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao ativar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fbeat-bg" onClick={onClose}>
      <div className="fbeat-box" role="dialog" aria-modal="true" aria-label="Ativar Classe" onClick={(e) => e.stopPropagation()}>
        <header className="fbeat-head">
          <h3 className="fbeat-title">Ativar</h3>
          <button className="fbeat-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>x</button>
        </header>
        <div className="fbeat-body">
          Deseja <strong>ativar</strong> "{titulo || "este registro"}"?
          {err ? <div className="fbeat-err">{err}</div> : null}
        </div>
        <footer className="fbeat-foot">
          <button className="fbeat-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="fbeat-btn fbeat-btn-ok" type="button" onClick={handleConfirmar} disabled={busy}>
            {busy ? "Ativando..." : "Ativar"}
          </button>
        </footer>
      </div>
    </div>
  );
}

